import React, { FC } from "react";

import classNames from "classnames";

import "./CircleLoader.scss";

enum CircleLoaderType {
  null,
  inline,
}

interface Props {
  type?: CircleLoaderType;
}

const CircleLoader: FC<Props> = props => {
  const buildClassNames = () => {
    return classNames(`circle-loader ${CircleLoaderType[props.type]}`);
  };
  return <div className={buildClassNames()} />;
};

export { CircleLoader, CircleLoaderType };
